import { EDevice, QUERY_PARAMS } from '@/constants';

function getQueryParam(paramName: string): string {
  const params = new URLSearchParams(window.location.search);
  return params.get(paramName) ?? '';
}

export function isDeviceAndroid(): boolean {
  const devideQueryParam = getQueryParam(QUERY_PARAMS.DEVICE);
  return devideQueryParam === EDevice.ANDROID;
}

export function isDeviceIos(): boolean {
  const devideQueryParam = getQueryParam(QUERY_PARAMS.DEVICE);
  return devideQueryParam === EDevice.IOS;
}

export function isDeviceKiosco(): boolean {
  const devideQueryParam = getQueryParam(QUERY_PARAMS.DEVICE);
  return devideQueryParam === EDevice.KIOSCO;
}

export function isIosAnalyticsReadyToUse(): boolean {
  return !!window?.webkit?.messageHandlers?.firebase?.postMessage;
}

export function isAndroidAnalyticsReadyToUse(): boolean {
  return !!window?.AnalyticsWebInterface?.logEvent;
}

export const getDeviceFromUrl = (): string => {
  const params = new URLSearchParams(window.location.search);
  return params.get(QUERY_PARAMS.DEVICE) || EDevice.WEB;
};
